import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryStockMovementItemSummary } from '@/renderer/services/inventoryStockMovementService';
import type { InventoryStockMovementFilterParams } from '@/renderer/types/inventory';

export function useInventoryStockMovementItemSummary(
  params: Omit<InventoryStockMovementFilterParams, 'page' | 'pageSize'>,
) {
  return useQuery({
    queryKey: queryKeys.inventory.stockMovementItemSummary(params),
    queryFn: async () => {
      const result = await fetchInventoryStockMovementItemSummary(params);
      if (!result.success || !result.data) {
        throw new Error(
          result.error ??
            'Failed to fetch inventory stock movement item summary',
        );
      }

      return result.data;
    },
    enabled: !!params.companyId && !!params.outletId,
  });
}
